import React, { useMemo } from "react";

import { Agent } from "../../../../../../../../../../services";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";
import { DisabledCheckbox } from "../../../../../../../../../../components";

const CabinetCellContent: React.FC<CabinetCellContent.Props> = ({ item }) => {
	const content = useMemo(
		() => item.isAccessToAccount ?? false,
		[item.isAccessToAccount],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			<DisabledCheckbox value={content} />
		</CellContentRoot>
	);
};

declare namespace CabinetCellContent {
	interface Props {
		item: Agent.Model;
	}
}

export default CabinetCellContent;
